import Sidebar from "../components/sidebar";
import AddForm from "../components/addform";
import ChangePassword from "../components/changePassword";
import Login from "../components/login";
import Navbar from "../components/navbar";

function AddFormPage() {
  return (
    <>
      <Sidebar>
        <AddForm />
      </Sidebar>
    </>
  );
}
export default AddFormPage;
